module.exports = __webpack_public_path__ + "img/black-top-arrow.e3e6d7c7.png";